import { useContext, useEffect } from 'react';
import { LayoutContext } from '@/contexts/LayoutContext';

export function useLayout() {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
}

/**
 * Hook to register a page as having a sidebar.
 * Uses a ref counter to prevent race conditions during route transitions.
 * Safe to call from multiple components simultaneously.
 */
export function useLayoutWithSidebar() {
  const { registerSidebar, unregisterSidebar } = useLayout();

  useEffect(() => {
    registerSidebar();
    return () => {
      unregisterSidebar();
    };
  }, [registerSidebar, unregisterSidebar]);
}
